import { useEffect, useRef } from 'react';
import { usePathname } from '@/i18n/routing';

/**
 * ページ遷移（URLの変更）を検知して、モーダルを閉じるフック
 * @param isOpen モーダルが開いているかどうか
 * @param closeModal モーダルを閉じる関数
 */
export const useCloseModalOnNavigation = (isOpen: boolean, closeModal: () => void) => {
  const pathname = usePathname();
  const prevPathnameRef = useRef(pathname);

  useEffect(() => {
    if (prevPathnameRef.current !== pathname) {
      if (isOpen) {
        closeModal();
      }
      prevPathnameRef.current = pathname;
    }
  }, [pathname, isOpen, closeModal]);
};
